import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import AssetsIcon from '../../../assets/images/assets.svg';

import Dashboard from './Components/Dashboard';
import Overview from './Components/Overview';

const Inbound = () => {
    const keysToRemove = ['Ftab_import', 'Ftab_planning', 'Ftab_export', 'Ftab_shprec'];
    keysToRemove.forEach(key => {
        localStorage.removeItem(key);
    });
    const initialTab = localStorage.getItem("Ftab_inbound") || 'dashboard';
    const isMounted = useRef(false);
    const [selectedButton, setSelectedButton] = useState(initialTab);
    const [apiNumber, setApiNumber] = useState(null);
    const [msgCount, setMsgCount] = useState();

    useEffect(() => {
        setSelectedButton(initialTab);
    }, [initialTab]);
    // console.log('555', selectedButton);
    const handleButtonClick = (button) => {
        setSelectedButton(button);
        localStorage.setItem('Ftab_inbound', button);
    };

    return (
        <>
            <div className="">
                <Header page_type='fsm' logo_url='/ForwarderShipments/Inbound' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='FSHPMNGR' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            <button className={selectedButton === 'dashboard' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dashboard')}>
                                                <img src={AssetsIcon} /> <span>Dashboard</span>
                                            </button>
                                            <button className={selectedButton === 'overview' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('overview')}>
                                                <img src={AssetsIcon} /> <span>Overview</span>
                                            </button>
                                        </div>
                                        <div className='search'>
                                            <div className="form-group has-search">

                                                {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lcontent">
                                        {selectedButton === 'dashboard' && <Dashboard />}
                                        {selectedButton === 'overview' && <Overview />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Inbound;